export const config = {
    build_timestamp: "2026-02-03T07:11:54.129Z",
    geoKey: "AIzaSyBeeIWUhRhc2ZW9oKxUugzu8y9JQgFVcvA",
    zoomSdkKey: "Egz3OjF7ITKvLvhHxRhxLNa5us9uJQ24oJX7",
    mockServices: false,
    env: "dh",
    serverUrl: "https://dh.eonlineworkshop.com/dhWebsite",
    imgUrl: "https://dh.eonlineworkshop.com/",
    razorAppKey: "rzp_live_yxYVhNWAkRzybF",
};
